import React, { Component } from "react";
import PropTypes from "prop-types";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";

import { store } from "../../redux/store";

import * as loyaltyAction from '../../redux/actions/loyalty';

import * as loyaltyRepo from "../../shared/repos/graphql/loyalty";

import ProductCard from "./ProductCard";
import styles from "./LoyaltyRewardBrandRefresh.module.css";
import { PUNCHH_TYPE } from "../../shared/constants/loyaltyType";

class LoyaltyRedeem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redeemables: []
    };
  }

  async componentDidMount() {
    await this.getLoyaltyRedeemables();
  }

  openDeliveryWidget = (link, id) => {
    const { openDeliveryWidget, setRedeemableItem } = this.props;
    setRedeemableItem({
      redeemableId: id,
      redeemableType: PUNCHH_TYPE.REDEEMABLE
    })

    openDeliveryWidget(link);
  }

  getLoyaltyRedeemables = async () => {
    const response = await loyaltyRepo.getLoyaltyRedeemables();
    store.dispatch(loyaltyAction.loyaltyRedeemables(response.data.loyaltyRedeemables))
    this.setState({
      redeemables: response.data.loyaltyRedeemables
    })
  };

  render() {
    const brandRefresh = isBrandRefreshEnabled();
    const Heading = brandRefresh ? "h2" : "p";
    const { points } = this.props;
    const { redeemables } = this.state;

    const notHaveLoyaltyRedeemables = !redeemables || redeemables.length <= 0;
    if (notHaveLoyaltyRedeemables) {
      return null;
    }

    return (
      <div className={brandRefresh ? styles.redeemSections : "mx-auto"}>
        {redeemables.map(redeemItem => {

          if ( redeemItem.items.length <= 0) return null

          const headingColor = points >= redeemItem.points ? "text-white" : "text-darkElevationPrimary";
          const statusId = `loyalty-level-${redeemItem.id || redeemItem.points}-status`;
          return (
            <div key={redeemItem.id || redeemItem.points} className={brandRefresh ? styles.rewardTier : "pt-6"}>
              <div>
                <Heading className={brandRefresh ? styles.sectionTitle : `${headingColor} text-2xl leading-6 tracking-[-0.3px] font-montserratBold font-bold`} aria-describedby={brandRefresh ? statusId : undefined}>
                  {redeemItem.title}
                </Heading>
                <p id={brandRefresh ? statusId : undefined} className={brandRefresh ? styles.visuallyHidden : "text-white text-sm leading-4 font-montserratMedium"}>
                  {`${
                    points >= redeemItem.points
                      ? "Unlocked!"
                      : `${redeemItem.points - points} more points needed`
                  }`}
                </p>
              </div>

              <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${brandRefresh ? "gap-5" : "gap-16"} ${brandRefresh ? styles.offerGrid : "mt-6"}`}>
                {redeemItem.items.map(item => {
                  const isBox = item.product.hasAssortments;
                  const isCustom =
                    item.product.options && item.product.options.length > 0;

                  let link = null;
                  if (points >= redeemItem.points) {
                    link = `/products/single/${item.product.id}`;

                    if (isBox) {
                      link = `/products/box/${item.product.id}`;
                    } else if (isCustom) {
                      link = `/products/customize/${item.product.id}`;
                    }
                  }
                  return (
                    <ProductCard
                      key={item.id}
                      image={item.product.productImageSmall}
                      title={item.product.title}
                      description={item.description}
                      id={item.id}
                      link={link}
                      pointsRemaining={Math.max(0, redeemItem.points - points)}
                      openDeliveryWidget={this.openDeliveryWidget}
                    />
                  );
                })}
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}

LoyaltyRedeem.propTypes = {
  points: PropTypes.number,
  openDeliveryWidget: PropTypes.func.isRequired,
  setRedeemableItem: PropTypes.func,
};

LoyaltyRedeem.defaultProps = {
  setRedeemableItem: () => {},
  points: 0
}

export default LoyaltyRedeem;
